var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 4.25C15.25 3.55964 14.6904 3 14 3C13.3096 3 12.75 3.55964 12.75 4.25L12.518 18.743L5.88388 13.1162C5.39573 12.628 4.60427 12.628 4.11612 13.1162C3.62796 13.6043 3.62796 14.3958 4.11612 14.8839L11.1716 21.9394C12.5049 23.2727 13.1716 23.9394 14 23.9394C14.8284 23.9394 15.4951 23.2727 16.8284 21.9394L23.8839 14.8839C24.372 14.3958 24.372 13.6043 23.8839 13.1162C23.3957 12.628 22.6043 12.628 22.1161 13.1162L15.482 18.743L15.25 4.25Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d000e043.svg";
export { ForwardRef as ReactComponent };